<div #container class="ocl-container-with-padding" fxLayout="column">
  <div #controls>
    <app-loading-header [loading]="false">Bill To</app-loading-header>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <app-bill-to-type [defaultValue]="defaultBillTo" [disabled]="disabled" (selection)="billTypeChanged($event)"></app-bill-to-type>
      <div fxLayout="row">
        <dx-button [visible]="!isPhone" id="upBtn" [disabled]="DisableUpBtn"
                   [icon]="'chevronup'" (click)="changeUp()" title="Up" style="margin-right: 4px;height: 26px"></dx-button>
        <dx-button [visible]="!isPhone" id="downBtn" [disabled]="DisableDownBtn"
                   [icon]="'chevrondown'" (click)="changeDown()" title="Down" style="margin-right: 4px;height: 26px"></dx-button>
        <dx-button [visible]="!isPhone" id="refreshBtn" [disabled]="patient === undefined || patient === null || selectedBillTo !== 'INSURANCE' || disabled"
                   [icon]="'refresh'" (click)="refresh(false)" hint='Refresh Patient Billing Info' title="Refresh" style="margin-right: 4px;height: 26px"></dx-button>
        <dx-button [visible]="!isPhone" id="undoBtn" [disabled]="patient === undefined || patient === null || selectedBillTo !== 'INSURANCE' || disabled"
                   [icon]="'undo'" (click)="refresh(true)" hint='Undo' title="Undo" style="margin-right: 4px;height: 26px"></dx-button>
        <dx-button [visible]="!isPhone" id="trashBtn" [disabled]="disabled || selectedBillTo !== 'INSURANCE' || selectedRowKeys.length === 0"
                   [icon]="'trash'" (click)="remove()" title="Remove" style="height: 26px"></dx-button>
        <dx-drop-down-button
          style="height: 26px"
          [visible]="isPhone"
          [splitButton]="false"
          [showArrowIcon]="false"
          [dropDownOptions]="{ width: 100 }"
          icon="overflow"
          [items]="buttons"
          [displayExpr]="'name'"
          [keyExpr]="'id'"
          (onItemClick)="onItemClick($event)">
        </dx-drop-down-button>
      </div>
    </div>
  </div>
  <div fxLayout="row">
    <dx-data-grid
      #grid
      [dataSource]="dataSource"
      [showBorders]="true"
      [showColumnLines]="true"
      [showRowLines]="true"
      [allowColumnResizing]="true"
      [disabled]="selectedBillTo !== 'INSURANCE'"
      [height]="gridHeight"
      style="margin-top: 10px; min-width: 100%!important;"
      [selection]="{ mode: 'single' }"
      [hoverStateEnabled]="true"
      [paging]="{ enabled: true, pageSize: 10 }"
      (selectedRowKeysChange)="selectionChange()"
      [keyExpr]="'id'"
      [loadPanel]="{enabled: true}"
      [(selectedRowKeys)]="selectedRowKeys"
      [wordWrapEnabled]="true"
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true">
      <dxo-scrolling [showScrollbar]="'always'" [mode]="'virtual'"></dxo-scrolling>
      <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

      <dxi-column caption="Bill Type" dataField="billType" [hidingPriority]="3"></dxi-column>
      <dxi-column caption="Payer" dataField="payer" [hidingPriority]="2"></dxi-column>
      <dxi-column caption="Insurance Id" dataField="insuranceId" [hidingPriority]="1"></dxi-column>
      <dxi-column caption="Group Number" dataField="groupNumber" [hidingPriority]="1"></dxi-column>
      <dxi-column caption="Order" dataField="order" dataType="number" alignment="center" [hidingPriority]="0"></dxi-column>
    </dx-data-grid>
  </div>
</div>
